import { Checkbox } from "@/components/ui/checkbox";
import { Slider } from "@/components/ui/slider";
import { idr } from "@/lib/api";
import { useT } from "@/lib/i18n";

const Group = ({ title, children }) => (
  <div className="border-b border-slate-100 py-4 last:border-0">
    <p className="mb-3 font-heading text-sm font-bold text-slate-900">{title}</p>
    {children}
  </div>
);

const Check = ({ id, label, checked, onChange }) => (
  <label htmlFor={id} className="flex cursor-pointer items-center gap-2 py-1 text-sm text-slate-700">
    <Checkbox id={id} data-testid={id} checked={checked} onCheckedChange={onChange} />
    {label}
  </label>
);

export default function SearchFilters({ f, setF, maxPrice, facilities }) {
  const t = useT();
  const toggle = (key, v) => setF({ ...f, [key]: f[key].includes(v) ? f[key].filter((x) => x !== v) : [...f[key], v] });
  return (
    <aside data-testid="search-filters" className="h-fit rounded-2xl border border-slate-200 bg-white px-5 py-2 lg:sticky lg:top-20">
      <Group title={t("Harga per malam")}>
        <Slider data-testid="filter-price-slider" min={0} max={maxPrice} step={50000} value={[f.price]}
          onValueChange={(v) => setF({ ...f, price: v[0] })} />
        <p className="mt-2 text-xs text-slate-500">{t("Hingga")} <b className="text-slate-800">{idr(f.price)}</b></p>
      </Group>
      <Group title={t("Bintang")}>
        {[5, 4, 3].map((s) => <Check key={s} id={`filter-star-${s}`} label={t("{n} bintang", { n: s })} checked={f.stars.includes(s)} onChange={() => toggle("stars", s)} />)}
      </Group>
      <Group title={t("Paling disukai")}>
        <Check id="filter-free-cancel" label={t("Pembatalan gratis")} checked={f.freeCancel} onChange={(v) => setF({ ...f, freeCancel: !!v })} />
        <Check id="filter-breakfast" label={t("Termasuk sarapan")} checked={f.breakfast} onChange={(v) => setF({ ...f, breakfast: !!v })} />
        <Check id="filter-pay-at-hotel" label={t("Bayar di hotel")} checked={f.payAtHotel} onChange={(v) => setF({ ...f, payAtHotel: !!v })} />
      </Group>
      <Group title={t("Fasilitas")}>
        {facilities.map((x, i) => <Check key={x} id={`filter-fac-${i}`} label={x} checked={f.fac.includes(x)} onChange={() => toggle("fac", x)} />)}
      </Group>
    </aside>
  );
}
